import React, { useContext, useState } from 'react';
import styles from './LayoutDefault.module.css';

import ChatbotBig from '../../Components/SideBar/assets/icons/chatbot-big.png';
import { AuthContext } from '../../Contexts/auth';
import ComboBox from '../ComboBox/ComboBox';
import OptionsDataByAttributePath from '../Options/optionsData/OptionsDataByAttributePath';
import { NavLink, useLocation } from 'react-router-dom';

function LayoutDefault({ children, customMainClass }) {
    const { authenticated, logout, clientList, clientSelected, setClientSelected } = useContext(AuthContext);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const handleLogout = () => {
        logout();
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const clientOptions = OptionsDataByAttributePath(clientList, ['description'], null, false)
    const hideComboBoxRoutes = ['/condominium'];
    const shouldShowComboBox = authenticated && !hideComboBoxRoutes.includes(location.pathname);

    return (
        <div className={styles.homepage}>
            <header className={styles.header}>
                <div style={{ display: 'flex', height: '100%', flexDirection: 'row' }}>
                    <NavLink to="/" className={styles.logo}>
                        <img src={ChatbotBig} alt="Condbot Big Icon" className={styles.logoImg} />
                    </NavLink>
                    <div style={{ display: 'flex', height: '100%', flexDirection: 'column' }} className={styles.logo}>
                        <div style={{ display: 'flex', height: '50%', width: '100%', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                            <span className={styles.titleCondBot}>CondBot</span>
                        </div>
                        {authenticated && shouldShowComboBox ?
                            <div style={{ display: 'flex', width: '100%', height: '50%', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                                <ComboBox
                                    setAttribute={setClientSelected}
                                    optionsData={clientOptions}
                                    style={{
                                        marginLeft: '10px',
                                        border: 'none',
                                        width: '100%',
                                        paddingTop: '0px',
                                        paddingLeft: '0px',
                                        marginLeft: '0px',
                                        outline: 'none',
                                        boxShadow: 'none',
                                        border: 'none'
                                    }}
                                    value={clientSelected}
                                    defaultValue={clientSelected}
                                />
                            </div>
                            : null
                        }
                    </div>
                </div>

                <nav className={`${styles.nav} ${isMenuOpen ? styles.open : ''}`}>
                    {authenticated && (
                        <NavLink to="/plans" className={({ isActive }) => isActive ? styles.active : undefined}>Planos</NavLink>
                    )}
                    {authenticated && (
                        <NavLink to="/rules" className={({ isActive }) => isActive ? styles.active : undefined}>Regras</NavLink>
                    )}
                    {authenticated && (
                        <NavLink to="/pending-rules" className={({ isActive }) => isActive ? styles.active : undefined}>Perguntas pendentes</NavLink>
                    )}
                    {authenticated && (
                        <NavLink to="/condominium" className={({ isActive }) => isActive ? styles.active : undefined}>Condomínio</NavLink>
                    )}
                    {authenticated && (
                        <NavLink to="/users" className={({ isActive }) => isActive ? styles.active : undefined}>Administradores</NavLink>
                    )}
                    {authenticated && (
                        <NavLink to="/units" className={({ isActive }) => isActive ? styles.active : undefined}>Unidades consumidoras</NavLink>
                    )}
                    {authenticated && (
                        <NavLink to="/residents" className={({ isActive }) => isActive ? styles.active : undefined}>Moradores</NavLink>
                    )}
                    {!authenticated && (
                        <NavLink to="/login" className={({ isActive }) => isActive ? styles.active : undefined}>Entrar</NavLink>
                    )}

                    {authenticated && (
                        <span onClick={handleLogout} className={styles.logoutButton}>Sair</span>
                    )}
                </nav>

                <div className={styles.burger} onClick={toggleMenu}>
                    <div className={styles.bar}></div>
                    <div className={styles.bar}></div>
                    <div className={styles.bar}></div>
                </div>
            </header >

            <main className={`${styles.main} ${customMainClass || ''}`}>
                {children}
            </main>
        </div >
    );
}

export default LayoutDefault;
